export const GUILD = 1;
export const USER = 2;
export const NONE = 3;
